(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glamlax-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('glamlax-hero')){
  customElements.define('glamlax-hero',class extends HTMLElement{
    connectedCallback(){
      this.slides=[...this.querySelectorAll('.gh-slide')];this.dots=[...this.querySelectorAll('[data-slide]')];this.index=0;
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches||!!window.Shopify?.designMode;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.querySelector('[data-prev]')?.addEventListener('click',()=>this.go(this.index-1,true),options);
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.go(this.index+1,true),options);
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.go(i,true),options));
      this.querySelector('[data-pause]')?.addEventListener('click',()=>{this.paused=!this.paused;this.sync();},options);
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.sync();},options);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.sync();},options);
      this.addEventListener('focusin',()=>{this.focused=true;this.sync();},options);
      this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.sync();});},options);
      this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1),true);}},options);
      this.addEventListener('touchstart',e=>{this.touch=[e.touches[0].clientX,e.touches[0].clientY];},{...options,passive:true});
      this.addEventListener('touchend',e=>{if(!this.touch)return;const dx=e.changedTouches[0].clientX-this.touch[0],dy=e.changedTouches[0].clientY-this.touch[1];if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)this.go(this.index+(dx<0?1:-1),true);this.touch=null;},{...options,passive:true});
      document.addEventListener('visibilitychange',()=>this.sync(),options);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.sync();},options);
      this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.go(i,true);}},options);
      this.observer=new IntersectionObserver(entries=>{this.offscreen=!entries[0].isIntersecting;this.sync();});this.observer.observe(this);this.sync();
    }
    go(index,manual=false){
      if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((s,i)=>{const active=i===this.index;s.classList.toggle('is-active',active);s.inert=!active;s.setAttribute('aria-hidden',String(!active));});
      this.dots.forEach((d,i)=>i===this.index?d.setAttribute('aria-current','true'):d.removeAttribute('aria-current'));
      if(manual&&this.querySelector('[data-status]'))this.querySelector('[data-status]').textContent=`Slide ${this.index+1} of ${this.slides.length}`;
      this.sync();
    }
    sync(){
      clearTimeout(this.timer);const button=this.querySelector('[data-pause]');if(button){button.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');button.firstElementChild.textContent=this.paused?'▷':'Ⅱ';}
      if(this.slides.length>1&&!this.paused&&!this.hovered&&!this.focused&&!this.offscreen&&!document.hidden)this.timer=setTimeout(()=>this.go(this.index+1),Number(this.dataset.interval)||6000);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glamlax-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glamlax-marquee')) customElements.define('glamlax-marquee', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.glamlax-marquee__track');
      this.original = this.querySelector('[data-marquee-original]');
      this.button = this.querySelector('button');
      if (!this.original || this.dataset.scrolling !== 'true') return;
      this.build = () => {
        this.track.querySelectorAll('[data-marquee-copy]').forEach(node => node.remove());
        const width = this.original.getBoundingClientRect().width;
        if (!width) return;
        this.style.setProperty('--marquee-distance', `${width}px`);
        const copies = Math.ceil(this.clientWidth / width) + 1;
        for (let i = 0; i < copies; i++) {
          const copy = this.original.cloneNode(true);
          copy.removeAttribute('data-marquee-original');
          copy.setAttribute('data-marquee-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
          this.track.append(copy);
        }
        this.dataset.ready = 'true';
      };
      this.toggle = () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
      };
      this.button?.addEventListener('click', this.toggle);
      this.resize = new ResizeObserver(this.build);
      this.resize.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.build(); });
    }
    disconnectedCallback() { this.resize?.disconnect(); this.button?.removeEventListener('click', this.toggle); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glamlax-offer-tab"]) return;
  try {
    
  if (!customElements.get('glamlax-offer-tab')) customElements.define('glamlax-offer-tab', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.connect = () => {
        const embed = document.getElementById(`app-embed-container-${this.dataset.formId}`);
        if (!embed?.shadowRoot || this.embed === embed) return;
        this.embed = embed;
        this.root = embed.shadowRoot;
        this.styleNode = document.createElement('style');
        this.styleNode.textContent = '[data-glamlax-offer-teaser] { visibility:hidden !important; pointer-events:none !important; }';
        this.root.append(this.styleNode);
        this.formObserver = new MutationObserver(() => this.sync());
        this.formObserver.observe(this.root, { childList:true, subtree:true });
        this.sync();
      };
      this.sync = () => {
        this.teaser = this.root?.querySelector('[data-testid="form-teaser"]');
        const embedVisible = this.embed && getComputedStyle(this.embed).display !== 'none';
        const busy = document.querySelector('cart-drawer.active, menu-drawer details[open], header details[open], dialog[open], #shopify-pc__banner');
        const checkout = /^\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname);
        this.button.hidden = !this.teaser || !embedVisible || !!busy || checkout;
        if (this.teaser) {
          if (!this.button.hidden) this.teaser.setAttribute('data-glamlax-offer-teaser', '');
          else this.teaser.removeAttribute('data-glamlax-offer-teaser');
        }
      };
      this.open = () => { if (this.teaser && !this.button.hidden) { this.button.hidden = true; this.teaser.click(); this.sync(); } };
      this.button.addEventListener('click', this.open);
      this.bodyObserver = new MutationObserver(() => { this.connect(); this.sync(); });
      this.bodyObserver.observe(document.body, { childList:true, subtree:true });
      this.stateObserver = new MutationObserver(() => this.sync());
      document.querySelectorAll('cart-drawer, menu-drawer, header, #shopify-pc__banner').forEach(node => this.stateObserver.observe(node,{attributes:true,subtree:true,attributeFilter:['open','class','style']}));
      this.connect();
    }
    disconnectedCallback() { this.bodyObserver?.disconnect(); this.formObserver?.disconnect(); this.stateObserver?.disconnect(); this.button?.removeEventListener('click',this.open); this.styleNode?.remove(); this.teaser?.removeAttribute('data-glamlax-offer-teaser'); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glamlax-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glamlax-preview-card')) {
  customElements.define('glamlax-preview-card', class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.loading) return;
      this.dataset.loading = 'true';
      try {
        const destination = new URL(this.dataset.url, location.origin);
        if (destination.origin !== location.origin) return;
        const endpoint = new URL(destination);
        endpoint.searchParams.set('section_id', 'glamlax-preview-card');
        const response = await fetch(endpoint);
        if (!response.ok) throw new Error('Product preview unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const card = doc.querySelector('.card-wrapper');
        if (!card || !card.querySelector('.card__heading a')) throw new Error('Missing product card');
        card.querySelectorAll('a[href]').forEach(link => { link.href = destination.href; });
        const action = card.querySelector('.quick-add__submit');
        if (action) {
          const link = document.createElement('a');
          link.className = action.className;
          link.href = destination.href;
          link.textContent = doc.querySelector('[data-preview-choose-label]').textContent;
          card.querySelector('.quick-add').replaceChildren(link);
        }
        card.querySelectorAll('quick-add-modal,script').forEach(node => node.remove());
        this.replaceWith(card);
      } catch (error) {
        this.dataset.loading = 'false';
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glamlax-promo-code"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glamlax-code-copy')) {
  customElements.define('glamlax-code-copy', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.querySelector('button').addEventListener('click', async () => {
        const code = this.querySelector('[data-code]').textContent.trim();
        const status = this.querySelector('[role="status"]');
        try {
          await navigator.clipboard.writeText(code);
          status.textContent = this.dataset.success;
          this.querySelector('[data-copy-label]').textContent = this.dataset.success;
        } catch (error) {
          status.textContent = this.dataset.failure;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glamlax-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glamlax-reviews')) {
  customElements.define('glamlax-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const on = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: this.abort.signal });
      this.track = this.querySelector('.gr-track');
      this.window = this.querySelector('.gr-window');
      this.cards = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.controls = this.querySelector('.gr-controls');
      this.toggle = this.querySelector('[data-toggle]');
      this.count = this.cards.length;
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || !!window.Shopify?.designMode;
      this.visible = false;
      this.hovered = false;
      if (!this.count) return;
      this.cloneCount = Math.min(3, this.count);
      const clone = card => {
        const el = card.cloneNode(true);
        el.removeAttribute('data-review');
        el.removeAttribute('data-shopify-editor-block');
        el.dataset.clone = '';
        el.setAttribute('aria-hidden', 'true');
        el.inert = true;
        return el;
      };
      this.track.prepend(...this.cards.slice(-this.cloneCount).map(clone));
      this.track.append(...this.cards.slice(0,this.cloneCount).map(clone));
      this.classList.add('is-ready');
      this.layout();
      this.resize = new ResizeObserver(() => this.layout());
      this.resize.observe(this.window);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, {threshold:.25});
      this.observer.observe(this);
      on(this.track, 'transitionend', event => { if(event.propertyName === 'transform') this.settle(); });
      on(this.querySelector('[data-next]'), 'click', () => { this.pause(); this.move(1); });
      on(this.querySelector('[data-prev]'), 'click', () => { this.pause(); this.move(-1); });
      this.dots.forEach((dot,i) => on(dot,'click', () => { this.pause(); this.go(i); }));
      on(this.toggle,'click', () => { this.paused = !this.paused; this.sync(); this.schedule(); });
      on(this,'pointerenter', event => { if(event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
      on(this,'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this,'focusin', event => { if(event.target !== this.toggle) this.pause(); });
      on(this.window,'keydown', event => {
        if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.pause(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
      });
      on(this.window,'pointerdown', event => { if(!event.isPrimary) return; this.pause(); this.pointer = {x:event.clientX,y:event.clientY,id:event.pointerId}; this.window.setPointerCapture(event.pointerId); });
      on(this.window,'pointerup', event => {
        if(!this.pointer || event.pointerId !== this.pointer.id) return;
        const dx = event.clientX-this.pointer.x, dy = event.clientY-this.pointer.y;
        this.pointer = null;
        if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) this.move(dx<0 ? 1 : -1);
      });
      on(this.window,'pointercancel', () => { this.pointer = null; });
      on(document,'visibilitychange', () => this.schedule());
      on(this.reduced,'change', () => { if(this.reduced.matches) this.pause(); });
      on(this,'shopify:block:select', event => { const i=this.cards.findIndex(card => card.dataset.review === event.detail.blockId); if(i>=0) { this.pause(); this.go(i,false); } });
      this.sync();
    }
    layout() {
      this.columns = Number(getComputedStyle(this).getPropertyValue('--gr-columns'));
      this.step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      this.controls.hidden = this.count <= this.columns;
      this.go(this.index,false);
    }
    normalized(i) { return (i%this.count+this.count)%this.count; }
    go(i,animate = true) {
      if(this.moving && animate) return;
      clearTimeout(this.finishTimer);
      this.index = i;
      this.track.style.transitionDuration = animate && !this.reduced.matches ? '550ms' : '0ms';
      this.track.style.transform = `translateX(-${(this.index+this.cloneCount)*this.step}px)`;
      this.moving = animate && !this.reduced.matches;
      this.sync();
      if(this.moving) this.finishTimer=setTimeout(() => this.settle(),600);
      else if(i<0 || i>=this.count) this.settle();
      this.schedule();
    }
    settle() {
      clearTimeout(this.finishTimer);
      this.moving = false;
      if(this.index<0 || this.index>=this.count) this.go(this.normalized(this.index),false);
    }
    move(delta) { if(this.count>this.columns) this.go(this.index+delta); }
    sync() {
      const start = this.normalized(this.index);
      this.dots.forEach((dot,i) => dot.setAttribute('aria-current',String(i===start)));
      this.cards.forEach((card,i) => { const visible=this.normalized(i-start)<this.columns; card.setAttribute('aria-hidden',String(!visible)); });
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      this.toggle.querySelector('span').textContent = this.paused ? '▷' : 'Ⅱ';
      this.dataset.position = String(start+1);
      this.dataset.paused = String(this.paused);
      this.track.setAttribute('aria-live',this.paused ? 'polite' : 'off');
    }
    pause() { this.paused = true; this.sync(); this.schedule(); }
    schedule() {
      clearTimeout(this.timer);
      if(!this.paused && !this.hovered && this.visible && !document.hidden && this.count>this.columns) this.timer=setTimeout(() => this.move(1),Number(this.dataset.interval)||5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer); clearTimeout(this.finishTimer);
      this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect();
      this.querySelectorAll('[data-clone]').forEach(el=>el.remove());
      this.initialized=false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
